import { SpEditorProvider } from '@/features/screenplay/components/editor/SpEditorProvider'
import { WorkspaceLayout } from '@/features/workspace'
import React from 'react'
import SbSidebar from '../components/SbSidebar'
import SbOptionBar from '../components/SbOptionBar'

import StoryboardMainContent from '../components/StoryboardMainContent'
import HeadlessSpEditor from '@/features/shared/component/HeadlessSpEditor'
import { useNavigate, useParams } from 'react-router-dom'
import { useScreenplayQuery } from '@/features/screenplay/queries/screenplay.queries'
import { FileText } from 'lucide-react'
import { Button } from '@/shared/components/ui/button'

import { NoScreenplayState } from '@/features/shared/component/NoScreenplayState'

const EditorWrapper = ({ children }: { children: React.ReactNode }) => (
    <SpEditorProvider>{children}</SpEditorProvider>
)

const StoryboardPage = () => {
    const { project_id } = useParams<{ project_id: string }>()
    const navigate = useNavigate()
    const { data: screenplay, isLoading } = useScreenplayQuery(project_id, 'master')

    const hasScreenplayContent = screenplay && screenplay.content && screenplay.content.length > 0

    return (
        <WorkspaceLayout
            ProviderWrapper={EditorWrapper}
            SidebarComponent={<SbSidebar />}
            optionBar={<SbOptionBar />}
        >
            {isLoading ? (
                <div className="flex h-full w-full items-center justify-center bg-background">
                    <p className="animate-pulse font-medium text-muted-foreground">Loading screenplay...</p>
                </div>
            ) : !hasScreenplayContent ? (
                <NoScreenplayState moduleName="Storyboards" />
            ) : (
                <>
                    <HeadlessSpEditor />
                    <StoryboardMainContent />
                </>
            )}
        </WorkspaceLayout>
    )
}

export default StoryboardPage
